import { useMemo } from "react";
import { resolveGmncBannerLink } from "../banners";
import { absUrl, useSiteOrigin } from "../useSiteOrigin";
import { useDesktop } from "../useDesktop";
import { useSettings } from "../useSettings";
import "./top-nha-cai.css";

function sortedBookmakers(raw) {
  if (!Array.isArray(raw)) return [];
  return [...raw].sort((a, b) => Number(b?.priority ?? 0) - Number(a?.priority ?? 0));
}

export default function TopNhaiCaiSideBar() {
  const desktop = useDesktop();
  const origin = useSiteOrigin();
  const { settings } = useSettings();
  const items = useMemo(
    () => sortedBookmakers(settings?.bookmarkers).filter((item) => String(item?.cta ?? "").trim()),
    [settings]
  );
  const reviewHref = resolveGmncBannerLink(settings?.gmnc_banner_link);

  if (!desktop || items.length === 0) return null;

  return (
    <aside className="kbv-home kbv-top-nha-cai" aria-label="Top nhà cái">
      <div className="kbv-top-nha-cai__card">
        <div className="kbv-top-nha-cai__head">Top nhà cái</div>
        <ul className="kbv-top-nha-cai__list">
          {items.map((item, index) => {
            const href = String(item?.cta ?? "").trim();
            const img = String(item?.feature_image ?? "").trim();
            const detail = String(item?.slogandetail_1 ?? "").trim();
            const value = String(item?.sloganvalue_1 ?? "").trim();
            return (
              <li key={`${href}-${index}`}>
                <div className="kbv-top-nha-cai__card-item">
                  <span className="kbv-top-nha-cai__bar" aria-hidden="true" />
                  <a className="kbv-top-nha-cai__media" href={href} target="_blank" rel="nofollow noopener noreferrer">
                    {img ? <img src={img} alt="" /> : null}
                  </a>
                  <div className="kbv-top-nha-cai__body">
                    {detail || value ? (
                      <a className="kbv-top-nha-cai__slogan" href={href} target="_blank" rel="nofollow noopener noreferrer">
                        {detail ? <span className="kbv-top-nha-cai__detail">{detail}</span> : null}
                        {value ? <span className="kbv-top-nha-cai__value">{value}</span> : null}
                      </a>
                    ) : null}
                    <a className="kbv-top-nha-cai__cta" href={href} target="_blank" rel="nofollow noopener noreferrer">
                      Tham gia ngay
                    </a>
                    {reviewHref ? (
                      <a className="kbv-top-nha-cai__review" href={reviewHref} target="_blank" rel="nofollow noopener noreferrer">
                        Review
                      </a>
                    ) : null}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
        <div className="kbv-top-nha-cai__more">
          <a href={absUrl(origin, "/top-nha-cai")}>Xem tất cả</a>
        </div>
      </div>
    </aside>
  );
}
